import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import Eyebrow from "@/components/Eyebrow";

const POSTS = [
  {
    slug: "kenaf-beglog-yield-rates",
    category: "Field Notes",
    date: "March 2025",
    title: "What kenaf-based beglog actually does to yield rates",
    excerpt:
      "Six months of harvest data from our Perlis facility. The numbers are not what conventional growers expect.",
    img: "/images/cendawan-sisir-hero.jpg",
  },
  {
    slug: "oku-employment-model",
    category: "Community",
    date: "February 2025",
    title: "Inside our OKU employment model at the Perlis facility",
    excerpt:
      "How Ecospora built a production line that works for disabled workers, single mothers, and the elderly — by design, not afterthought.",
    img: "https://images.unsplash.com/photo-1755606045126-1aeb4f0e7c2d?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
  {
    slug: "upm-composting-trial",
    category: "Research",
    date: "January 2025",
    title: "First results from the UPM substrate composting trial",
    excerpt:
      "Universiti Putra Malaysia's early findings on converting spent mushroom substrate into agricultural-grade compost.",
    img: "https://images.unsplash.com/photo-1763844599737-be3850c60cea?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
  },
];

const Journal = () => (
  <div data-testid="journal-page">
    <section className="section-y bg-ecospora-cream pt-40">
      <div className="container-x">
        <Reveal className="max-w-2xl mb-20">
          <Eyebrow className="mb-6">Journal</Eyebrow>
          <h1 className="font-display text-5xl md:text-6xl font-bold tracking-tight text-ecospora-green-deep leading-[1.05]">
            From the field. <span className="italic font-light">From the lab.</span>
          </h1>
          <p className="mt-6 text-lg text-ecospora-charcoal/75 leading-relaxed">
            Field notes, research updates, and stories from inside the system.
          </p>
        </Reveal>

        <Reveal stagger className="grid md:grid-cols-3 gap-8">
          {POSTS.map((post) => (
            <JournalCard key={post.slug} {...post} />
          ))}
        </Reveal>
      </div>
    </section>
  </div>
);

const JournalCard = ({ slug, category, date, title, excerpt, img }) => (
  <Link
    to={`/journal/${slug}`}
    className="group block rounded-2xl overflow-hidden border border-ecospora-green-deep/10 bg-white hover:-translate-y-1 transition-all duration-500"
    data-testid={`journal-card-${slug}`}
  >
    <div className="aspect-video overflow-hidden bg-ecospora-green-soft">
      <img
        src={img}
        alt={title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
      />
    </div>
    <div className="p-8">
      <div className="flex items-center gap-3 mb-4">
        <span className="text-[11px] font-semibold tracking-[0.18em] uppercase text-ecospora-green-mid">
          {category}
        </span>
        <span className="text-ecospora-charcoal/30">·</span>
        <span className="text-xs text-ecospora-charcoal/50">{date}</span>
      </div>
      <h2 className="font-display text-xl font-semibold tracking-tight text-ecospora-green-deep leading-snug mb-3">
        {title}
      </h2>
      <p className="text-sm text-ecospora-charcoal/70 leading-relaxed mb-6">{excerpt}</p>
      <span className="inline-flex items-center gap-2 text-sm font-semibold text-ecospora-green-deep group-hover:gap-3 transition-all">
        Read more <ArrowRight size={15} strokeWidth={1.5} />
      </span>
    </div>
  </Link>
);

export default Journal;
